import { Flex } from "@chakra-ui/layout";

function FilterSeparator() {
  return <Flex w="2px" h="100%" bg="gray.300" />;
}

export default FilterSeparator;
